import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import MaintainerChargeStationDetailScreen from './screens/MaintainerChargeStationDetailScreen';
import MaintainerChargePointDetailScreen from '../MaintainerChargePoint/screens/MaintainerChargePointDetailScreen';
import MaintainerChargeStationListScreen from './screens/MaintainerChargeStationListScreen';

function MaintainerChargeStation(props) {
    return (
        <KT01BaseLayout isFullScreen={true}>
            <div className="container-fluid px-0">
                <Routes>
                    <Route path="" element={<MaintainerChargeStationListScreen />} />
                    <Route path=":chargeStationId" element={<MaintainerChargeStationDetailScreen />} />
                    <Route
                        path=":chargeStationId/point/:chargePointId"
                        element={<MaintainerChargePointDetailScreen />}
                    />
                    {/* <Route path=":stationId/point/add" element={<ChargePointAddScreen />} />
                    <Route
                        path=":stationId/point/:pointId/edit"
                        element={<ChargePointAddScreen />}
                    />
                    <Route
                        path=":stationId/point/:pointId/transaction/:transactionId"
                        element={<ChargeTransactionDetailScreen />}
                    /> */}
                    <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
                </Routes>
            </div>
        </KT01BaseLayout>
    );
}

export default MaintainerChargeStation;
